export function tradingWalletDepositNetworkImageGet(
  network: string | undefined,
): string {
  if (!network) {
    return "/usd-coin-usdc-logo.svg";
  }

  switch (network.toLowerCase()) {
    case "arbitrum":
      return "/images/icons/arbitrum-icon.svg";
    case "bitcoin":
      return "/images/icons/btc-icon.svg";
    case "eth":
      return "/images/icons/eth-icon.svg";
    case "sol":
      return "/images/icons/sol-icon.svg";
    case "bsc":
      return "/images/icons/bsc-icon.svg";
    case "base":
      return "/images/icons/base-icon.svg";
    default:
      return "/usd-coin-usdc-logo.svg";
  }
}
